import { render, staticRenderFns } from "./databases.vue?vue&type=template&id=43d4a137&"
import script from "./databases.vue?vue&type=script&lang=js&"
export * from "./databases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports